export default "__VITE_ASSET__B3I1KuW0__"